import { Component } from '@theme/component';

/**
 * @typedef {Object} ColorSelectionLineItemDetail
 * @property {string} [colorRef]
 * @property {string} [colorName]
 * @property {string} [colorHex]
 * @property {string} [colorBase]
 * @property {string} [colorHandle]
 */

const COLOR_SELECTION_LINE_ITEM_EVENTS = {
  confirmed: 'color_selection_confirmed',
  cleared: 'color_selection_cleared',
};

const COLOR_SELECTION_LINE_ITEM_SELECTORS = {
  pickerRoot: 'tint-color-picker',
  colorInput: '[data-color-selection-input="color"]',
  hexcodeInput: '[data-color-selection-input="hexcode"]',
  baseInput: '[data-color-selection-input="base"]',
  tintHandleInput: '[data-color-selection-input="tint_handle"]',
};

class ColorSelectionLineItem extends Component {
  connectedCallback() {
    super.connectedCallback();

    const colorInput = /** @type {HTMLInputElement | null} */ (
      this.querySelector(COLOR_SELECTION_LINE_ITEM_SELECTORS.colorInput)
    );
    const hexcodeInput = /** @type {HTMLInputElement | null} */ (
      this.querySelector(COLOR_SELECTION_LINE_ITEM_SELECTORS.hexcodeInput)
    );
    const baseInput = /** @type {HTMLInputElement | null} */ (
      this.querySelector(COLOR_SELECTION_LINE_ITEM_SELECTORS.baseInput)
    );
    const tintHandleInput = /** @type {HTMLInputElement | null} */ (
      this.querySelector(COLOR_SELECTION_LINE_ITEM_SELECTORS.tintHandleInput)
    );

    if (!colorInput && !hexcodeInput && !baseInput && !tintHandleInput) return;

    const pickerRoot = this.closest(COLOR_SELECTION_LINE_ITEM_SELECTORS.pickerRoot);
    if (!pickerRoot) return;

    pickerRoot.addEventListener(
      COLOR_SELECTION_LINE_ITEM_EVENTS.confirmed,
      (event) => {
      /** @type {{ detail?: ColorSelectionLineItemDetail }} */
      // @ts-ignore
        const customEvent = event;
        const detail = customEvent.detail || {};

        if (colorInput) {
          const label = `${detail.colorRef || ''} ${
            detail.colorName || ''
          }`.trim();
          colorInput.value = label;
          colorInput.disabled = !label;
        }

        if (hexcodeInput) {
          hexcodeInput.value = detail.colorHex || '';
          hexcodeInput.disabled = !detail.colorHex;
        }

        if (baseInput) {
          baseInput.value = detail.colorBase || '';
          baseInput.disabled = !detail.colorBase;
        }

        if (tintHandleInput) {
          tintHandleInput.value = detail.colorHandle || '';
          tintHandleInput.disabled = !detail.colorHandle;
        }
      },
    );

    pickerRoot.addEventListener(COLOR_SELECTION_LINE_ITEM_EVENTS.cleared, () => {
      if (colorInput) {
        colorInput.value = '';
        colorInput.disabled = true;
      }

      if (hexcodeInput) {
        hexcodeInput.value = '';
        hexcodeInput.disabled = true;
      }

      if (baseInput) {
        baseInput.value = '';
        baseInput.disabled = true;
      }

      if (tintHandleInput) {
        tintHandleInput.value = '';
        tintHandleInput.disabled = true;
      }
    });
  }
}

customElements.define('color-selection-line-item', ColorSelectionLineItem);
